import {
  type TypedUseSelectorHook,
  useDispatch as useReactReduxDispatch,
  useSelector as useReactReduxSelector
} from 'react-redux';
import type { AppDispatch } from 'config/reduxStore';
import type { RootState } from 'redux/rootReducer';

export const useSelector: TypedUseSelectorHook<RootState> =
  useReactReduxSelector;
export const useDispatch: () => AppDispatch = useReactReduxDispatch;
